import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ConfigService,
  LanguageState,
  injectAuthService,
} from '@osos/shared/legacy-core';
import { ComponentBase } from '@osos/shared/utility';
import { Observable, combineLatest, takeUntil } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-osos-ai',
  templateUrl: './osos-ai.component.html',
  styleUrls: ['./osos-ai.component.scss'],
  standalone: false,
})
export class OsosAiComponent extends ComponentBase implements OnInit {
  @Input() configActive: boolean;
  @Output() configActiveChange = new EventEmitter<boolean>();
  protected authService = injectAuthService();
  protected configService = inject(ConfigService);
  rtlDir$: Observable<boolean> = this.store.select(
    LanguageState.currentLanguageRTLDirection,
  );
  aiUrl;
  constructor(public store: Store) {
    super();
  }
  ngOnInit() {
    this.rtlDir$
      .pipe(
        tap(
          (rtl) =>
            (this.aiUrl =
              this.configService.configuration.OSOS_AI_URL +
              '/' +
              (rtl ? 'ar' : 'en')),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe();
    combineLatest([
      this.authService.getAccessToken(),
      this.authService.getCurrentUserId(),
    ])
      .pipe(
        tap(([token, userId]) => {
          window.addEventListener('message', (event) => {
            // Check the origin to ensure it's trusted
            if (event.origin === this.configService.configuration.OSOS_AI_URL) {
              const iframe = document.querySelector(
                'iframe.osos-ai',
              ) as HTMLIFrameElement;
              if (iframe) {
                iframe.contentWindow.postMessage(
                  {
                    token: token,
                    userId: userId,
                  },
                  this.configService.configuration.OSOS_AI_URL,
                );
              }
            }
          });
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
